"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _camelCase = _interopRequireDefault(require("../utils/camelCase"));
var dictionaryTermsApi = function dictionaryTermsApi(allDictionaryTermsApi, productLineId) {
  return typeof allDictionaryTermsApi === 'string' ? (0, _axios["default"])({
    url: allDictionaryTermsApi,
    params: {
      productLineId: productLineId
    },
    method: 'GET',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    return (0, _camelCase["default"])(response.data);
  }) : allDictionaryTermsApi(productLineId);
};
var _default = exports["default"] = dictionaryTermsApi;
//# sourceMappingURL=dictionaryTermsApi.js.map